<!--销售订单 - 待确认订单(自录) - 验收 - 修改 -->
<template>
  <div style="width: 100%;height: 100%">
    <el-row type="flex" class="row-bg" justify="end" style="width: 100%; flex-wrap: wrap;">
      <el-button size="small" style="margin-right: 20px;margin-top: 30px" type="primary" @click="preview"
        v-show="printStatus === 1">
        打印预览
      </el-button>
      <el-button size="small" style="margin-right: 20px; margin-top: 30px" type="primary" @click="websitePricePrint"
        v-show="fun_dic[100030202]">
        对标网站价格打印
      </el-button>
    </el-row>
    <el-row :data="titleData">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li><span>供应商</span>：{{ titleData[0].SUPPLIER_NAME }}</li>
          <li><span>项目点</span>：{{ titleData[0].PROJECT_NAME }}</li>
          <li><span>项目点地址</span>：{{ titleData[0].PROJECT_ADDRESS }}</li>
          <li><span>送货日期</span>：{{ titleData[0].SEND_DAY }}</li>
          <li><span>订购总金额</span>：{{ titleData[0].TOTAL_SUPPLIER_FEE }}</li>
          <li><span>订单备注</span>：{{ titleData[0].ORDER_COMMENT }}</li>
        </ul>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="{ span: 12, offset: 0 }" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li><span>制单人</span>：{{ managername }}</li>
          <li><span>档口</span>：{{ titleData[0].DK_NAME }}</li>
          <li><span>项目点电话</span>：{{ titleData[0].PROJECT_TELPHONE }}</li>
          <li><span>订单编号</span>：{{ titleData[0].ORDER_CODE }}</li>
          <li><span>实收总金额</span>：{{ titleData[0].REAL_TOTAL_SUPPLIER_FEE }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-button style="margin-bottom: 20px" type="primary" @click="downloadAllBatchReport">批量下载批次报告</el-button>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column label="产品" prop="SHORT_NAME" min-width="100"></el-table-column>
          <el-table-column label="品牌" prop="BRAND" min-width="100"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION" min-width="100"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="CATALOG_NAME" label="分类"></el-table-column>
          <el-table-column prop="PRICE" label="单价" min-width="80"></el-table-column>
          <el-table-column prop="BEFORE_TAX_PRICE" label="不含税单价" min-width="80"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订购数量"></el-table-column>
          <el-table-column prop="NEED_COUNT" label="送货数量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.NEED_COUNT" @change="changeRowNeedCount(scope.row)"
                v-if="fun_dic[100030203]">
              </el-input>
              <span v-else>{{ scope.row.NEED_COUNT }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="COUNT" label="实收数量" min-width="80">
            <template slot-scope="scope">
              <el-row>
                <el-col :span="24">
                  <el-input size="small" :placeholder="scope.row.PRODUCT_COUNT" v-model="scope.row.COUNT"
                    @change="(val) => { setValue(val, scope.row) }" clearable></el-input>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column prop="SUPPLIER_REAL_FEE" label="实收总金额" min-width="80"></el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="备注" min-width="80"></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="text" @click="openEdit(scope.row)" v-show="fun_dic[100030201]">修改</el-button>
              <el-button type="text" @click="openAllEdit(scope.row)">修改全部</el-button><br>
              <!-- 亦芙德专用 -->
              <el-button type="text" size="small" icon="el-icon-download" @click="downloadBatchReport(scope.row)"
                :disabled="scope.row.BATCH_REPORT_ID == 0">
                下载批次报告
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row :data="titleData">
      <el-col>
        <p>收货时间:</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <p>送货员：</p>
      </el-col>
      <el-col :span="6">
        <p>项目经理：</p>
      </el-col>
      <el-col :span="6">
        <p>厨师长：</p>
      </el-col>
      <el-col :span="6">
        <p>验收人员：</p>
      </el-col>
    </el-row>
    <el-row class="buttonGroup">
      <el-button size="small" @click="__confirm" type="primary">确认订单</el-button>
      <el-button size="small" @click="confirmWithNeedCount" type="primary" v-show="fun_dic[100030204]">
        一键验收为送货数量
      </el-button>
      <el-button size="small" @click="__confirm" :disabled="pName || ppName" v-show="fun_dic[100030206]">
        确认修改
      </el-button>
      <el-button size="small" @click="updateSend">修改为送货数量</el-button>
      <el-button size="small" @click="batchUpdateSendCont" type="primary" v-show="fun_dic[100030203]">
        批量修改送货数量
      </el-button>
      <el-button size="small" @click="updateOrder" v-show="fun_dic[100030205]">修改为订购数量</el-button>
    </el-row>
    <el-row style="margin-top: 10px;">
      <el-col>
        <el-steps :active="this.statusFlag" finish-status="success" v-show="this.statusFlag !== 0" :space="200">
          <el-step :title="item.T" :description="item.D" v-for="item in checkData" :key="item.value"></el-step>
        </el-steps>
        <h4 v-show="this.statusFlag === 0" style="color:#E6A23C">暂无流程记录信息</h4>
      </el-col>
    </el-row>
    <!--表格弹出框   下列为实收数量与订购数量不一致的产品，请再次确认-->
    <el-dialog title="提示" :visible.sync="tableVisible" width="40%" center>
      <p style="color: red; text-align: center">下列为单价或数量有变动的产品，请再次确认</p>
      <el-table :data="changeProducts" stripe border style="width: 100%">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品" min-width="80"></el-table-column>
        <el-table-column prop="PRICE" label="单价" min-width="60"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位" min-width="80"></el-table-column>
        <el-table-column prop="COUNT" label="订购数量" min-width="80"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeTable()">取 消</el-button>
        <el-button size="small" type="primary" @click="subDataToServer()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改产品" center :visible.sync="editFormVisible" width="600px">
      <el-form :model="editForm" ref="editForm" :label-width="formLabelWidth">
        <el-form-item label="产品名称：">
          <span>{{ name }}</span>
        </el-form-item>
        <el-form-item label="送货数量：">
          <el-input v-model="editForm.NEED_COUNT"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button @click="submitEdit" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 打印显示送货数量还是订购数量 -->
    <el-dialog title="打印项" center :visible.sync="printSetFormVisible" width="600px">
      <el-form :label-width="formLabelWidth">
        <el-form-item label="产品名称：">
          <el-radio v-model="printRadio" label="0">订购数量</el-radio>
          <el-radio v-model="printRadio" label="1">送货数量</el-radio>
        </el-form-item>
        <el-form-item label="单据类型：">
          <el-radio v-model="docTypeRadio" label="0">长单子</el-radio>
          <el-radio v-model="docTypeRadio" label="1">短单子</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="printSetFormVisible = false">取 消</el-button>
        <el-button @click="submitPrint">打印</el-button>
      </div>
    </el-dialog>
    <!-- 修改全部信息 -->
    <el-dialog title="修改全部信息" center :visible.sync="editAllFormVisible" width="600px">
      <el-form :model="editAllForm" ref="editAllForm" :label-width="formLabelWidth">
        <el-form-item label="产品名称：">
          <span>{{ Editname }}</span>
        </el-form-item>
        <el-form-item label="采购价：">
          <el-input v-model="editAllForm.BUY_PRICE" @change="countPrice" :disabled="isisdisabled"></el-input>
        </el-form-item>
        <el-form-item label="报损后单价：">
          <span> {{ editAllForm.WPRICE }}</span>
        </el-form-item>
        <el-form-item label="销售价：">
          <el-input v-model="editAllForm.REAL_PRICE" :disabled="isisdisabled"></el-input>
        </el-form-item>
        <el-form-item label="订购数量：">
          <el-input v-model="editAllForm.PRODUCT_COUNT"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="editAllForm.PRODUCT_COMMENT"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAll">取 消</el-button>
        <el-button @click="submitEditAll" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="打印预览" center :visible.sync="productionDateOnlineDialog" width="600px" @close="cancelPreviewPrint">
      <el-form :model="productionDateOnlineForm" ref="productionDateOnlineForm">
        <el-form-item label="生产日期：" :label-width="formLabelWidth">
          <el-date-picker v-model="productionDateOnlineForm.PRODUCTION_DATE" type="date" placeholder="选择日期"
            value-format="yyyy-MM-dd" clearable style="width: 100% !important;">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="productionDateOnlineDialog = false">取 消</el-button>
        <el-button @click="submitPreviewPrint">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  orderConfirmDetailFun, updateOrderFun, updateZLFun, updateBookFun, updateSendFun, updateNewDetailFun_Limit, confirmOrderFun, downloadOrderBatchReportFun, priceCountFun, // notOrderDetailFun,
} from 'api/sellOrder';
import { getActionFun } from 'api/login';
import util from '../../assets/common/util';
import http from '@/assets/common/http';
import { downloadBatchReport } from '@/assets/api/shopOrderManage';
import validation from '@/assets/common/validation';

export default {
  data () {
    return {
      fromName: ['websitePricePrint', 'sellOrderPrint', 'sellOrderCustomPrintDetail', 'toBeConfirmePrintDetail', 'OrderConfirmList'],
      toName: ['websitePricePrint', 'sellOrderPrint', 'sellOrderCustomPrintDetail', 'toBeConfirmePrintDetail'],
      managername: sessionStorage.getItem('name'),
      tableData: [],
      productArray: [],
      titleData: [
        {
          SUPPLIER_NAME: '',
          SEND_DAY: '',
          ORDER_CODE: '',
          TOTAL_GYS_FEE: '',
          REAL_TOTAL_GYS_FEE: '',
        },
      ],
      printStatus: '',
      pName: false,
      ppName: false,
      tableVisible: false,
      changeProducts: [],
      TOTAL_FEE: 0,
      editFormVisible: false,
      editForm: false,
      name: '',
      loading: false,
      formLabelWidth: '100px',
      printSetFormVisible: false,
      printRadio: '0',
      docTypeRadio: '0',
      editAllFormVisible: false,
      editAllForm: {},
      Editname: '',
      checkData: [],
      statusFlag: 0,
      PAGE_ID: '1000302', // 页面ID 一旦规定不要轻易改动
      fun_dic: {
        100030201: 0, 100030202: 0, 100030203: 0, 100030204: 0, 100030205: 0, 100030206: 0,
      },
      isisdisabled: false,
      productionDateOnlineDialog: false,
      productionDateOnlineForm: {
        PRODUCTION_DATE: '',
      },
    };
  },
  beforeRouteLeave (to, from, next) {
    // 离开页面前清除订单ID
    if (!this.toName.includes(to.name)) {
      sessionStorage.removeItem('orderId');
    }
    next();
  },
  beforeRouteEnter (to, from, next) {
    next((that) => {
      // 判断是否通过修改URL进入
      if (!that.fromName.includes(from.name) || !sessionStorage.getItem('orderId')) {
        that.$message.show({ text: '请从待确认订单列表进入验收', type: 'warning' });
        that.$router.go(-1);
      } else {
        that.getOrderDetailList();
        that.queryBeforeFun();
      }
    });
  },
  methods: {
    // 改变表格字体颜色
    tableRowClassName ({ row }) {
      if (Number(row.PRODUCT_COUNT) !== Number(row.REAL_COUNT)) {
        return 'warning-row';
      }
      return '';
    },
    getOrderDetailList () {
      const params = {
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      orderConfirmDetailFun(params).then((result) => {
        if (result) {
          this.tableData = result[0].DETAIL.map((item) => Object.assign(item, {
            COUNT: item.REAL_COUNT,
            BEFORE_TAX_PRICE: Number(item.BEFORE_TAX_PRICE).toFixed(2),
            PRICE: item.REAL_PRICE,
            NEED_COUNT: item.NEED_COUNT < 0 ? item.PRODUCT_COUNT : item.NEED_COUNT,
          }));
          this.titleData = result[0].TITLE;
          this.printStatus = result[0].PRINT_FLAG;
          this.statusFlag = result[0].OR[0].RN;
          this.checkData = result[0].OR[0].DATA;
          if (result[0].TITLE[0].AGENT) {
            sessionStorage.setItem('AGENT', result[0].TITLE[0].AGENT);
          } else {
            sessionStorage.setItem('AGENT', 0);
          }
        } else {
          this.tableData = [];
          this.titleData = [];
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    updateOrderStatus () {
      const params = {
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      confirmOrderFun(params).then((result) => {
        this.$message.show({ text: '订单确认成功', type: 'success' });
        this.$router.push({ name: 'OrderConfirmList' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 改变送货数量
    changeRowNeedCount (row) {
      if (this.$util.JudgmentUnit(row.TYPE_UNIT) ? !validation.数量正数0验证(row.NEED_COUNT) : !validation.数量整数正数0验证(row.NEED_COUNT)) {
        this.$message.show({ text: '请输入正确的送货数量', type: 'warning' });
        this.pName = true;
        return false;
      }
      this.pName = false;
    },
    // ------------------------改变实收数量
    setValue (val, row) {
      if (!validation.数量正数0验证(val)) {
        this.ppName = true;
        this.$message.show({ text: '请输入正数实收数量', type: 'error' });
        return false;
      }
      if (!util.JudgmentUnit(row.TYPE_UNIT)) { // 如果不是
        const beInter = (val % 1 === 0);
        if (beInter == false) {
          this.$message.show({ text: '单位不是KG的，只能输入整数', type: 'error' });
          this.ppName = true;
          return false;
        }
      }
      row.SUPPLIER_REAL_FEE = Number(row.PRICE * val).toFixed(2);
      this.ppName = false;
    },
    // 全部确认
    __confirm () {
      if (!this.tableData.length) {
        this.isAllDetailThirdPartySupplierSend();
        return;
      }
      this.changeProducts = this.tableData.filter((item) => item.COUNT !== item.REAL_COUNT || item.PRICE !== item.REAL_PRICE);
      if (this.changeProducts.length !== 0) {
        this.tableVisible = true;
      } else {
        this.subDataToServer();
      }
    },
    // --------------确认按钮
    subDataToServer () {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const submitArr = this.tableData.map((item, index) => ({
            ORDER_DETAIL_ID: Number(item.ORDER_DETAIL_ID),
            PRODUCT_CODE: item.PRODUCT_CODE,
            NEW_COUNT: Number(item.COUNT),
            PRICE: Number(item.PRICE),
          }));
          const params = {
            ORDER_ID: sessionStorage.getItem('orderId'),
            PRODUCT_ARRAY: submitArr,
          };
          updateZLFun(params).then((result) => {
            this.$message.show({ text: '修改成功', type: 'success' });
            this.tableVisible = false;
            this.updateOrderStatus();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    closeTable () {
      this.tableVisible = false;
      this.getOrderDetailList();
    },
    updateOrder () {
      const params = {
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      updateBookFun(params).then((result) => {
        this.$message.show({ text: '订单修改成功', type: 'success' });
        this.getOrderDetailList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        document.body.style.cursor = 'default';
      });
    },
    updateSend () {
      const params = {
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      updateSendFun(params).then((result) => {
        this.$message.show({ text: '订单修改成功', type: 'success' });
        this.getOrderDetailList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        document.body.style.cursor = 'default';
      });
    },
    openEdit (row) {
      this.editFormVisible = true;
      this.editForm = row;
      this.name = row.PRODUCT_NAME;
      this.ORDER_DETAIL_ID = row.ORDER_DETAIL_ID;
    },
    close () {
      this.editFormVisible = false;
    },
    submitEdit () {
      if (util.JudgmentUnit(this.editForm.TYPE_UNIT) ? !validation.数量正数0验证(this.editForm.NEED_COUNT) : !validation.数量整数正数0验证(this.editForm.NEED_COUNT)) {
        this.$message.show({ text: '请输入正确的送货数量', type: 'error' });
        return false;
      }
      const params = {
        DETAIL_ID: this.ORDER_DETAIL_ID,
        NEED_COUNT: Number(this.editForm.NEED_COUNT),
        TC_ID: Number(sessionStorage.getItem('ORDER_TC_ID')),
      };
      this.loading = true;
      updateNewDetailFun_Limit(params).then((result) => {
        this.loading = false;
        this.$message.show({ text: '操作成功', type: 'success' });
        this.editFormVisible = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
        this.getOrderDetailList();
      });
    },
    // 修改全部
    openAllEdit (row) {
      this.editAllFormVisible = true;
      this.editAllForm = row;
      this.Editname = row.PRODUCT_NAME;
    },
    // 全部提交
    submitEditAll () {
      if (!validation.数量正数0验证(this.editAllForm.PRODUCT_COUNT)) {
        this.$message.show({ text: '请输入数字', type: 'error' });
        return false;
      }
      if (!util.JudgmentUnit(this.editAllForm.TYPE_UNIT)) { // 如果不是
        const beInter = (this.editAllForm.PRODUCT_COUNT % 1 === 0);
        if (beInter == false) {
          this.$message.show({ text: '单位不是KG的，只能输入整数', type: 'error' });
          return false;
        }
      }
      if (!validation.价格正数0验证(this.editAllForm.REAL_PRICE)) {
        this.$message.show({ text: '请输入正确的价格', type: 'warning' });
        return false;
      }
      const params = {
        ORDER_DETAIL_ID: this.editAllForm.ORDER_DETAIL_ID,
        NEW_COUNT: Number(this.editAllForm.PRODUCT_COUNT),
        MODIFY_FLAG: 1,
        PRICE: this.editAllForm.REAL_PRICE,
        PRODUCT_COMMENT: this.editAllForm.PRODUCT_COMMENT,
        SUPPLIER_ID: this.titleData[0].SUPPLIER_ID,
        PRODUCT_CODE: this.editAllForm.PRODUCT_CODE,
      };
      this.loading = true;
      updateOrderFun(params).then((result) => {
        this.loading = false;
        this.$message.show({ text: '操作成功', type: 'success' });
        this.editAllFormVisible = false;
        this.getOrderDetailList();
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 全部关闭
    closeAll () {
      this.editAllFormVisible = false;
    },
    // -------------------------打印
    preview () {
      const params = {
        SERVICE_ID: '12013',
        OTYPE: 7,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        TC_ID: this.titleData[0].TC_ID,
        IS_SUPPLIER_CLIENT: 0,
      };
      http.post(params).then((result) => {
        if (result[0].USE_PRINT_TEMPLATE == 1) {
          sessionStorage.setItem('TEM_TCID', this.titleData[0].TC_ID);
          if (result[0].TEMPLATE_CONTENT && result[0].TEMPLATE_CONTENT.length > 0 && result[0].TEMPLATE_CONTENT[0].tableSet.includes('生产日期(线上填写)')) this.productionDateOnlineDialog = true;
          else this.$router.push({ name: 'sellOrderCustomPrintDetail' });
        } else {
          this.printSetFormVisible = true;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitPreviewPrint () {
      sessionStorage.setItem('未签收销售单打印 生产日期(线上填写)', this.productionDateOnlineForm.PRODUCTION_DATE);
      this.$router.push({ name: 'sellOrderCustomPrintDetail' });
    },
    cancelPreviewPrint () {
      this.$refs.productionDateOnlineForm.resetFields();
    },
    submitPrint () {
      this.$router.push({ name: 'sellOrderPrint' });
      sessionStorage.setItem('countFlag', this.printRadio);
      sessionStorage.setItem('isShortDocFlag', this.docTypeRadio);
      sessionStorage.setItem('printRealFlag', 0);
    },
    // 控制功能按钮
    queryBeforeFun () {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu (e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    websitePricePrint () {
      const params = {
        SERVICE_ID: '10051',
        OTYPE: 11,
        GYS_ID: sessionStorage.getItem('tcId'),
      };
      http.post(params).then((res) => {
        this.$prompt('', '请输入乘算比例(%)', {
          confirmButtonText: '确定', cancelButtonText: '取消', inputValue: sessionStorage.getItem('websitePriceRate') ? sessionStorage.getItem('websitePriceRate') : '', center: true,
        }).then(({ value }) => {
          if (/(^([1-9]\d*)$)/.test(value)) {
            this.$router.push({ name: 'websitePricePrint' });
            sessionStorage.setItem('countFlag', 0); // 0表示打印订购数量,1表示打印送货数量
            sessionStorage.setItem('isShortDocFlag', 0);
            sessionStorage.setItem('printRealFlag', 0);
            sessionStorage.setItem('websitePriceRate', value);
          } else {
            this.$message.show({ text: '请输入正整数', type: 'warning' });
          }
        }).catch((e) => { });
      }).catch((e) => {
        this.$message.show({ text: e, type: 'error' });
      });
    },
    // 下载批次报告
    downloadBatchReport (row) {
      const params = {
        BATCH_REPORT_ID: row.BATCH_REPORT_ID,
      };
      downloadBatchReport(params).then((res) => {
        if (res[0]) {
          this.$message.show({ text: '下载成功', type: 'success' });
          window.open(this.$util.getURLLocalHost(res[0].FILE_PATH));
        }
      });
    },
    downloadAllBatchReport () {
      const params = {
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      downloadOrderBatchReportFun(params).then((res) => {
        if (res.length) {
          this.$message.show({ text: '下载成功', type: 'success' });
          window.open(this.$util.getURLLocalHost(res[0].FILE_PATH));
        } else {
          this.$message.show({ text: '订单内所有商品未上传批次报告', type: 'warning' });
        }
      });
    },
    // 批量修改送货数量
    async batchUpdateSendCont () {
      let countFlag = 0;
      this.tableData.forEach((ele) => {
        const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
        if (!reg.test(ele.NEED_COUNT)) {
          // this.$message.show({ text: '请输入送货数量', type: 'error' });
          countFlag = 1;
        }
        if (!util.JudgmentUnit(ele.TYPE_UNIT)) { // 如果不是
          const beInter = (ele.NEED_COUNT % 1 === 0);
          if (beInter == false) {
            // this.$message.show({ text: '单位不是KG的，只能输入整数', type: 'error' });
            countFlag = 1;
          }
        }
      });
      if (countFlag == 1) {
        this.$message.show({ text: '请输入送货数量，且单位不是KG的，只能输入整数', type: 'error' });
        return;
      }
      const paramsList = [];
      const resList = [];
      const erroeList = [];
      let flag = 0;
      this.tableData.forEach((item, index) => {
        paramsList.push({
          SERVICE_ID: '10009',
          OTYPE: 48,
          DETAIL_ID: item.ORDER_DETAIL_ID,
          NEED_COUNT: Number(item.NEED_COUNT),
          TC_ID: Number(this.titleData[0].TC_ID),
        });
      });
      for (const item of paramsList) {
        try {
          // eslint-disable-next-line no-await-in-loop
          const res = await http.post(item);
          resList.push(res);
        } catch (e) {
          erroeList.push(e);
        }
      }
      if (erroeList.length !== 0) {
        flag = 2;
        // eslint-disable-next-line no-console
        console.log(erroeList);
      }
      if (flag == 0) {
        this.getOrderDetailList();
        this.$message.show({ text: '批量修改送货数量成功', type: 'success' });
      } else {
        // eslint-disable-next-line no-case-declarations
        let errText = '';
        // eslint-disable-next-line no-case-declarations
        let newArr = new Set(erroeList);
        newArr = Array.from(newArr);
        for (const item of newArr) {
          errText = `${item},${errText}`;
        }
        this.$message.show({ text: errText, type: 'error' });
        this.getOrderDetailList();
      }
    },
    countPrice () {
      // this.editAllForm.REAL_PRICE = Math.round(this.editAllForm.BUY_PRICE*(1+this.addPoint/100) *100)/100
      if (validation.价格正数验证(this.editAllForm.BUY_PRICE)) {
        const params = {
          PRICE: this.editAllForm.BUY_PRICE,
          CATALOG_ID: this.editAllForm.CATALOG_ID,
        };
        priceCountFun(params).then((result) => {
          this.editAllForm.REAL_PRICE = result[0];
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        this.$message.show({ text: '请输入正数的采购价', type: 'warning' });
        this.editAllForm.BUY_PRICE = '';
      }
    },
    confirmWithNeedCount () {
      const params = {
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      updateSendFun(params).then((res) => {
        this.updateOrderStatus();
      }).catch((error) => {
        this.$message.show({ text: '订单中有商品没有设置送货数量，无法以送货数量验收', type: 'error' });
        document.body.style.cursor = 'default';
      });
    },
    isAllDetailThirdPartySupplierSend () {
      const params = {
        SERVICE_ID: '10010',
        OTYPE: 19,
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      http.post(params).then((res) => {
        if (res.length && res[0].ALL_SENDED_BY_THIRD_PARTY_SUPPLIER) {
          this.updateOrderStatus();
        } else {
          this.$message.show({ text: '空订单', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>
<style scoped>
ul {
  list-style: none;
  min-height: 50px;
  padding: 0;
  margin-top: 25px;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}

p {
  font-size: 14px;
}

.buttonGroup {
  margin-top: 20px;
  flex: auto;
}

.buttonGroup .el-button {
  float: right;
  margin-right: 10px;
}

li span {
  display: inline-block;
  width: 70px;
  text-align-last: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/selfOrderCheck.vue